var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "mb-5 elevation-2",
    attrs: {
      headers: _vm.headers,
      items: _vm.items,
      "hide-actions": "",
      "item-key": "setting_id",
      search: _vm.search
    },
    scopedSlots: _vm._u([
      {
        key: "items",
        fn: function(props) {
          return [
            _c(
              "tr",
              {
                class: props.selected ? "greyLighter" : "",
                attrs: { active: props.selected }
              },
              [
                !_vm.coLoader
                  ? _c(
                      "td",
                      [
                        _c("v-layout", { attrs: { column: "" } }, [
                          _c("label", {
                            staticClass: "primary--text",
                            domProps: { textContent: _vm._s(props.item.name) }
                          }),
                          _vm._v(" "),
                          _c("label", {
                            staticClass: "italic--text",
                            domProps: {
                              textContent: _vm._s(props.item.description)
                            }
                          })
                        ])
                      ],
                      1
                    )
                  : _c(
                      "td",
                      { staticStyle: { width: "70%" } },
                      [
                        _c("notification-type-loader", {
                          attrs: { "loader-type": "text" }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                !_vm.coLoader
                  ? _c(
                      "td",
                      { staticStyle: { width: "10%" } },
                      [
                        _c("v-checkbox", {
                          attrs: {
                            "input-value": props.item.app,
                            color: "secondary",
                            "hide-details": ""
                          },
                          on: {
                            change: function($event) {
                              _vm.onClickCheckbox(props, "app")
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "td",
                      { staticStyle: { width: "10%" } },
                      [
                        _c("notification-type-loader", {
                          attrs: { "loader-type": "checkbox" }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                !_vm.coLoader
                  ? _c(
                      "td",
                      { staticStyle: { width: "10%" } },
                      [
                        _c("v-checkbox", {
                          attrs: {
                            "input-value": props.item.email,
                            color: "secondary",
                            "hide-details": ""
                          },
                          on: {
                            change: function($event) {
                              _vm.onClickCheckbox(props, "email")
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "td",
                      { staticStyle: { width: "10%" } },
                      [
                        _c("notification-type-loader", {
                          attrs: { "loader-type": "checkbox" }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                !_vm.coLoader
                  ? _c(
                      "td",
                      { staticStyle: { width: "10%" } },
                      [
                        _c("v-checkbox", {
                          attrs: {
                            "input-value": props.item.sms,
                            color: "secondary",
                            "hide-details": ""
                          },
                          on: {
                            change: function($event) {
                              _vm.onClickCheckbox(props, "sms")
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "td",
                      { staticStyle: { width: "10%" } },
                      [
                        _c("notification-type-loader", {
                          attrs: { "loader-type": "checkbox" }
                        })
                      ],
                      1
                    )
              ]
            )
          ]
        }
      }
    ]),
    model: {
      value: _vm.selected,
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02fe52c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02fe52c9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/components/profile-notification-data-table/template.html
// module id = null
// module chunks = 